import interfaces from "../../__downloaded__/interfaces.json";
import { TypeHierarchy } from "@coremedia/view-dispatcher";

const typeHierarchy: TypeHierarchy = {
  ...interfaces,
};

export default typeHierarchy;
